module.exports = __webpack_public_path__ + "static/media/theme-landing-4.16b7c05c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Landing/theme-landing-4.jpg
// module id = 362
// module chunks = 0